package fr.manyverse.app.presentation.error

import fr.manyverse.app.domain.error.NetworkError
import fr.manyverse.app.domain.error.UnreadableImageError
import fr.manyverse.app.domain.error.ValidationError
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.error_image_unreadable
import manyverse.shared.generated.resources.error_network
import manyverse.shared.generated.resources.error_unexpected
import org.jetbrains.compose.resources.getString

/**
 * Message à afficher à l'utilisateur pour un échec, jamais vide.
 *
 * Seul le message d'une [ValidationError] est montré tel quel : écrit par le domaine, il décrit
 * ce que l'utilisateur doit corriger. Une [UnreadableImageError] a son propre message traduit.
 * Les autres messages viennent du serveur ou des SDK, en anglais et sans action possible : ils
 * sont remplacés par un texte traduit qui dit quoi faire.
 * L'erreur d'origine est déjà remontée à Sentry par `mapToDomainException`.
 */
suspend fun Throwable.toUserMessage(): String = when (this) {
    is UnreadableImageError -> getString(Res.string.error_image_unreadable)
    is ValidationError -> message?.takeIf { it.isNotBlank() } ?: getString(Res.string.error_unexpected)
    is NetworkError -> getString(Res.string.error_network)
    else -> getString(Res.string.error_unexpected)
}
